import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, ListChecks, PlusCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Skeleton } from '../ui/skeleton';
import { api } from '../../lib/api';
import { EventCard } from './EventCard';

// Landing-page spotlight: the next upcoming debate or candidate event
// across all of Kawartha Lakes, with the two most useful actions.
export const NextEventSpotlight = ({ testId = 'next-event-spotlight' }) => {
  const [state, setState] = useState({ loading: true, next: null, count: 0, error: false });

  useEffect(() => {
    api.get('/election/events/next')
      .then((r) => setState({ loading: false, next: r.data?.next || null, count: r.data?.upcoming_count || 0, error: false }))
      .catch(() => setState({ loading: false, next: null, count: 0, error: true }));
  }, []);

  return (
    <section className="rounded-2xl border-2 border-[#C9A84C]/70 bg-[#FBF7EE] p-5 sm:p-6" data-testid={testId}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs font-black uppercase tracking-widest text-[#8a6d2c] inline-flex items-center gap-2"><CalendarClock className="h-4 w-4" /> Next election event in Kawartha Lakes</p>
        {state.count > 0 && <span className="text-xs font-semibold text-slate-600" data-testid="next-event-upcoming-count">{state.count} upcoming event{state.count === 1 ? '' : 's'}</span>}
      </div>
      <div className="mt-3">
        {state.loading ? (
          <div className="space-y-2"><Skeleton className="h-6 w-2/3" /><Skeleton className="h-4 w-1/2" /><Skeleton className="h-4 w-1/3" /></div>
        ) : state.next ? (
          <EventCard ev={state.next} compact testId="next-event-card" />
        ) : (
          <p className="text-sm text-slate-700" data-testid="next-event-empty">{state.error ? 'The event list could not be loaded right now.' : 'No upcoming events are listed yet. Know of one? Submit it below.'}</p>
        )}
      </div>
      <div className="mt-4 flex flex-wrap gap-3">
        <Button asChild className="h-11 bg-[#1a2744] hover:bg-[#24406f] text-white font-bold btn-press" data-testid="next-event-list-btn">
          <Link to="/elections/events"><ListChecks className="h-4 w-4 mr-1.5" /> Election Event List</Link>
        </Button>
        <Button asChild variant="outline" className="h-11 border-[#1a2744] text-[#1a2744] font-bold btn-press bg-white" data-testid="next-event-submit-btn">
          <Link to="/elections/submit-event"><PlusCircle className="h-4 w-4 mr-1.5" /> Submit an Event</Link>
        </Button>
      </div>
    </section>
  );
};
